import { Component, OnInit, Input, ViewChild, AfterViewInit, SimpleChanges } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Variable } from '../models/variable';

@Component({
    selector: 'app-variable-display',
    templateUrl: './variable-display.component.html',
    styleUrls: ['./variable-display.component.css'],
    standalone: false
})
export class VariableDisplayComponent implements OnInit, AfterViewInit {
  
  @Input() variables!: Variable[];
  @Input() title!: string;
  @ViewChild(MatSort) sort!: MatSort;
  
  constructor() { }

  public dataSource = new MatTableDataSource<Variable>();

  filterText?: string;
  allSelected: boolean = true;
  scopeFilterControl = new FormControl();
  scopeOptions?: string[];
  scopeFilters: string[] = [];
  displayedColumns = ['name', 'value', 'scope'];
  statusFilters = ['added', 'deleted', 'edited', 'unchanged'];

  ngOnInit() {
    this.dataSource.data = this.variables;
    this.scopeOptions = this.variables.map(v => v.scope).filter((v, i, a) => a.indexOf(v) === i);
    this.scopeFilters = [...this.scopeOptions];
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.variables) {
      this.variables = changes.variables.currentValue;
      this.ngOnInit();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  addStatusFilter(status: string) {
    this.statusFilters.push(status);
    this.applyFilters();
  }

  removeStatusFilter(status: string) {
    this.statusFilters = this.statusFilters.filter(f => f !== status);
    this.applyFilters();
  }

  isChecked(): boolean {
    return this.scopeOptions!.length > 0 && this.scopeFilters.length === this.scopeOptions!.length;
  }

  isIndeterminate(): boolean {
    return this.scopeFilters.length > 0 && this.scopeFilters.length < this.scopeOptions!.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.scopeFilters = [...this.scopeOptions!];
    } else {
      this.scopeFilters = [];
    }
    this.applyFilters();
  }

  applyFilters() {
    const listCopy = [...this.variables];
    this.dataSource.data = listCopy
      .filter(v => this.statusFilters.includes(v.status))
      .filter(v => this.scopeFilters.includes(v.scope))
      .sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
  }

  getStatusClass(v: Variable) {
    if (v.status === 'deleted') {
      return 'red';
    } else if (v.status === 'edited') {
      return 'blue';
    } else if (v.status === 'added') {
      return 'green';
    }
    else {
      return 'white';
    }
  }
}
